import { useContext, useEffect } from 'react';
import { AppContext } from '../../../main/context/Provider';
import withFilteredQueryRequest from '../../shared/components/table/withFilteredRequest';
import { changeWebPageTitleService } from '../../../infrastructure/services';
import { Private_Routes } from '../../../main/constants';
import { AddButton } from '../../shared/components/AddButton';
import ProjectStatusTable from '../components/ProjectStatusTable';

export const ProjectStatusPage = () => {
    const { setNestedRoutes, isSkinSmart, lang } = useContext(AppContext);

    const ProjectStatusList = withFilteredQueryRequest(
        'project-status/projects-status-filtered-list',
        ProjectStatusTable
    );

    const { webPage } = changeWebPageTitleService(isSkinSmart, 'Estados');

    useEffect(() => {
        setNestedRoutes([
            {
                label: 'Estados',
                route: Private_Routes.PROJECT_STATUS_PAGE,
            },
        ]);
    }, [lang]);

    return (
        <div className='row'>
            <div className='col-12'>
                <div className='card'>
                    <div className='card-body'>
                        <div className='mb-3'>
                            <AddButton href={Private_Routes.CREATE_PROJECT_STATUS} />
                        </div>
                        <ProjectStatusList />
                    </div>
                </div>
            </div>
        </div>
    );
};
